import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yxzx",
  "use": "icon-yxzx-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yxzx\">\n<g id=\"icon-yxzx_Menu/yxzx\">\n<g id=\"icon-yxzx_video\">\n<path d=\"M11.05 7.74017C11.25 7.85564 11.25 8.14432 11.05 8.25979L5.95 11.2043C5.75 11.3198 5.5 11.1754 5.5 10.9445L5.5 5.0555C5.5 4.82456 5.75 4.68023 5.95 4.7957L11.05 7.74017ZM6.5 6.26794V9.73204L9.5 7.99998L6.5 6.26794Z\" fill=\"#282C33\" />\n<path d=\"M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM3 3L3 13H13V3H3Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yxzx.svg
// module id = CLtq
// module chunks = 140